import module from 'nominas/finiquitos/module.js'

const schema = {
  finiquito: {
    id: 'number',
    escenarios: 'number',
  },
}

export class NominasFiniquitosService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/nominas/finiquitos', {
      schema,
    })
  }

  post (idProyecto, idColaborador, data) {
    return this.$http.post('/api/nominas/finiquitos', data, {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
      },
      schema,
    })
  }
}

module.service('NominasFiniquitos', NominasFiniquitosService)



// WEBPACK FOOTER //
// ./src/nominas/finiquitos/services/Finiquitos.js